import { BenchmarkGranularity } from "../types/common";

//Routes
export const ACTIVATION_ROOT_ROUTE = "activation";
export const ACTIVATION_HOME_ROUTE = `${ACTIVATION_ROOT_ROUTE}-home`;
export const ACTIVATION_PROJECT_ROUTE = `${ACTIVATION_ROOT_ROUTE}-project`;
export const ACTIVATION_SETTINGS_ROUTE = `${ACTIVATION_ROOT_ROUTE}-settings`;

// URLS
export const ACTIVATION_ROOT_URL = "/activation";
export const ACTIVATION_HOME_URL = `/home`;
export const ACTIVATION_SETTINGS_URL = `/settings`;

//Default params
export const DEFAULT_ACTIVATION_GRANULARITY = BenchmarkGranularity.WEEKLY;
export const DEFAULT_ACTIVATION_WEB_SOURCE = "Total";
